import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * design-system.md section 6/8: the auth loading state is a skeleton, never
 * a spinner. Shown by `StartPage`/`SignupPage` while `isInitialized` is
 * pending, so its shape mirrors the borderless card the resolved
 * `LoginPage`/`SignupPage` render, to avoid a layout shift once data loads.
 */
export const LoginSkeleton = () => {
  return (
    <div className="max-w-screen-xl mx-auto h-screen pt-8">
      <div className="h-full">
        <div className="max-w-sm mx-auto h-full flex flex-col justify-center">
          <Card>
            <CardContent className="space-y-8">
              <Skeleton className="w-4/5 h-[50px] mx-auto" />
              <Skeleton className="w-full h-9" />
              <Skeleton className="w-full h-9" />
              <Skeleton className="w-full h-9" />
              <Skeleton className="w-2/5 h-9 mx-auto" />
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};
